import { config as prod } from './env/prod';
import { config as stg } from './env/stg';
import { config as dev } from './env/dev';
import { config as local } from './env/local';
import { Config, EnvConfig } from './types';

export * from './types';
export const isTest = process.env.NODE_ENV === 'test';

const env = (process.env.REACT_APP_STAGE as EnvConfig['env']) || 'local';

const configOptions = {
  prod,
  stg,
  dev,
  local,
};

const config: Config = {
  ...configOptions[env],
  isLocal() {
    return this.env === 'local';
  },
  isDev() {
    return this.env === 'dev';
  },
  isProd() {
    return this.env === 'prod';
  },
  isStg() {
    return this.env === 'stg';
  },
};

export { config, env };
